var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMarttiLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 486.6 116",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-3 {\n        fill: #001932;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-7 {\n        fill: #fff;\n      }\n\n      .cls-8 {\n        fill: #07192b;\n      }\n\n      .cls-9 {\n        fill: #ff6200;\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-4);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 38.2,
    y1: 82.2,
    x2: 55.9,
    y2: 43.5,
    gradientTransform: "translate(0 134) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffb600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7027"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 82.3,
    y1: 38.3,
    x2: 27.9,
    y2: 59.8,
    gradientTransform: "translate(0 134) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff601c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 78.5,
    y1: 69.2,
    x2: 60.8,
    y2: 107.9,
    gradientTransform: "translate(0 134) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffb600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7027"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 34.4,
    y1: 113.1,
    x2: 88.8,
    y2: 91.5,
    gradientTransform: "translate(0 134) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff601c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 21,
    y1: 51.7,
    x2: 42.5,
    y2: 106.2,
    gradientTransform: "translate(0 134) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff601c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 95.8,
    y1: 99.7,
    x2: 74.2,
    y2: 45.2,
    gradientTransform: "translate(0 134) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff601c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb600"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M38.2,47l34.5,34.5c1.9,1.9,3.4,4.1,4.4,6.6,1,2.5,1.5,5.1,1.5,7.7s-.5,5.3-1.5,7.7c-1,2.5-2.5,4.7-4.4,6.6-12.7,12.7-34.5,3.7-34.5-14.3v-48.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.2,47l34.5,34.5c1.9,1.9,3.4,4.1,4.4,6.6,1,2.5,1.5,5.1,1.5,7.7s-.5,5.3-1.5,7.7c-1,2.5-2.5,4.7-4.4,6.6-12.7,12.7-34.5,3.7-34.5-14.3v-48.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M38.2,47l34.5,34.5c1.9,1.9,3.4,4.1,4.4,6.6,1,2.5,1.5,5.1,1.5,7.7s-.5,5.3-1.5,7.7c-1,2.5-2.5,4.7-4.4,6.6-12.7,12.7-34.5,3.7-34.5-14.3v-48.8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M78.6,69.6l-34.5-34.5c-1.9-1.9-3.4-4.1-4.4-6.6-1-2.5-1.5-5.1-1.5-7.7s.5-5.3,1.5-7.7c1-2.5,2.5-4.7,4.4-6.6,12.7-12.7,34.5-3.7,34.5,14.3v48.8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M78.6,69.6l-34.5-34.5c-1.9-1.9-3.4-4.1-4.4-6.6-1-2.5-1.5-5.1-1.5-7.7s.5-5.3,1.5-7.7c1-2.5,2.5-4.7,4.4-6.6,12.7-12.7,34.5-3.7,34.5,14.3v48.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M78.6,69.6l-34.5-34.5c-1.9-1.9-3.4-4.1-4.4-6.6-1-2.5-1.5-5.1-1.5-7.7s.5-5.3,1.5-7.7c1-2.5,2.5-4.7,4.4-6.6,12.7-12.7,34.5-3.7,34.5,14.3v48.8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M69.7,38.1l-34.5,34.5c-1.9,1.9-4.1,3.4-6.6,4.4-2.5,1-5.1,1.5-7.7,1.5s-5.3-.5-7.7-1.5c-2.5-1-4.7-2.5-6.6-4.4-12.7-12.7-3.7-34.5,14.3-34.5h48.8Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M69.7,38.1l-34.5,34.5c-1.9,1.9-4.1,3.4-6.6,4.4-2.5,1-5.1,1.5-7.7,1.5s-5.3-.5-7.7-1.5c-2.5-1-4.7-2.5-6.6-4.4-12.7-12.7-3.7-34.5,14.3-34.5h48.8Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M47,78.5l34.5-34.5c1.9-1.9,4.1-3.4,6.6-4.4,2.5-1,5.1-1.5,7.7-1.5s5.3.5,7.7,1.5c2.5,1,4.7,2.5,6.6,4.4,12.7,12.7,3.7,34.5-14.3,34.5h-48.8Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47,78.5l34.5-34.5c1.9-1.9,4.1-3.4,6.6-4.4,2.5-1,5.1-1.5,7.7-1.5s5.3.5,7.7,1.5c2.5,1,4.7,2.5,6.6,4.4,12.7,12.7,3.7,34.5-14.3,34.5h-48.8Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M234.6,101.3V27.3h-.4l-29.5,73.9h-7.7l-29.6-73.9h-.2v73.9h-12.8V13.7h20.1l26.3,67.1,26.4-67.1h20.1v87.6h-12.8,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M312.6,101.3v-10.2h-.2c-4.6,7.8-12.9,11.8-22.2,11.8-19.2,0-34.8-14.4-34.8-33.4s15-35.6,34.3-35.6,17.6,3.5,22.7,11h.2v-9.2h12.3v65.6h-12.3ZM312.8,68.6c0-12.8-9.2-23.4-22.8-23.4s-22.4,10.5-22.4,23.4,10.1,23.1,22.4,23.1,22.8-10.6,22.8-23.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M335.4,101.3V35.7h11.5v5.9h.2c3-4.4,8-7.2,16.7-7.7v12.7c-10.6.4-16.1,6.9-16.1,17.9v36.8h-12.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M379,101.3v-54.3h-8.9v-11.2h8.9V13.7h12.3v22h10.8v11.2h-10.8v54.3h-12.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M411.2,101.3v-54.3h-11.2v-11.2h11.2V13.7h12.3v22h10.8v11.2h-10.8v54.3h-12.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 440.5,
    y: 18.4,
    width: 11.7,
    height: 11.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M439.6,101.3V35.7h12.3v65.6h-12.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M463.4,101.1h-2v-10.6h-4.5v-1.5h11v1.5h-4.5v10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M476.1,101.1l-3.3-7.2c-.4-.9-.7-1.7-1-2.5,0,.9.1,1.9.1,2.6v7.1h-1.9v-12.1h2.5l3.6,7.7c.5,1,.5,1.2.9,2.1.4-1.1.6-1.5.9-2.1l3.6-7.7h2.5v12h-1.9v-7.1c0-.8,0-1.7.1-2.6-.3,1-.6,1.7-1.1,2.6l-3.3,7.1h-1.6Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMarttiLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/martti_logo.0873036098930884614bd7909d1cd18b.svg";